package pl.zar.tikthrow.util

import kotlinx.browser.window

/**
 * The web app talks to the same origin that serves it (in production Caddy reverse-proxies the
 * whole domain to the Ktor server), so the API base URL is derived from the page's own origin
 * instead of being hardcoded to localhost:8080. This keeps OAuth redirects and API calls on the
 * correct host/subdomain whether the app is opened from the dev server or the production domain.
 *
 * For local development against a separate backend, override it by defining a global before the
 * bundle loads, e.g. in index.html: `window.TIKTHROW_API_URL = "http://localhost:8080";`
 */
actual val apiBaseUrl: String
    get() {
        val override = (window.asDynamic().TIKTHROW_API_URL as? String)
            ?.takeIf { it.isNotBlank() }
            ?.trimEnd('/')
        if (override != null) return override

        val origin = window.location.origin
        return if (origin.isNotBlank() && origin != "null") origin else "http://localhost:8080"
    }
